import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllUsersComponent } from './all-users.component';
import { DeleteUserModalContent } from './delete-users-modal/delete-users.modal';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@bt/shared';
import {NgSelectizeModule} from 'ng-selectize';
import { ChangePasswordModalContent } from './change-password-modal';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    NgSelectizeModule,
    FontAwesomeModule
  ],
  entryComponents:[DeleteUserModalContent, ChangePasswordModalContent],
  declarations: [
    AllUsersComponent, DeleteUserModalContent, ChangePasswordModalContent
  ],
})
export class AllUsersModule { }


// WEBPACK FOOTER //
// ./src/app/admin/all-users/all-users.module.ts